import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getApplicationPhaseList,
	addNewApplicationPhase,
	updateApplicationPhase,
	deleteApplicationPhase,
	getApplicationPhase,
} from '../applicationPhase/thunk';

export const initialState = {
	itemApplicationPhaseList: [],
	itemApplicationPhaseDetail: null,
	isApplicationPhaseLoading: false,
	isApplicationPhaseSuccess: false,

	applicationPhaseList: [],
	applicationPhaseListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ApplicationPhaseSlice = createSlice({
	name: 'ApplicationPhases',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getApplicationPhase.fulfilled, (state, action) => {
			state.isApplicationPhaseLoading = false;
			state.isApplicationPhaseSuccess = true;
			state.itemApplicationPhaseDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getApplicationPhase.pending, state => {
			state.isApplicationPhaseLoading = true;
			state.isApplicationPhaseSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getApplicationPhase.rejected, (state, action) => {
			state.isApplicationPhaseLoading = false;
			state.isApplicationPhaseSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getApplicationPhaseList.pending, state => {
			state.isApplicationPhaseSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getApplicationPhaseList.fulfilled, (state, action) => {
			state.itemApplicationPhaseList = action.payload;
			state.applicationPhaseList = action.payload;
			state.isLoadingList = false;
			state.isApplicationPhaseSuccess = true;

			let applicationPhaseListSelect = [];
			action.payload.map(item =>
				applicationPhaseListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.applicationPhaseListSelect = applicationPhaseListSelect;
		});
		builder.addCase(getApplicationPhaseList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isApplicationPhaseSuccess = true;
		});
		builder.addCase(addNewApplicationPhase.fulfilled, (state, action) => {
			state.itemApplicationPhaseList.push(action.payload);
			state.applicationPhaseList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewApplicationPhase.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewApplicationPhase.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateApplicationPhase.fulfilled, (state, action) => {
			state.itemApplicationPhaseList = state.itemApplicationPhaseList.map(applicationPhase =>
				applicationPhase.applicationPhasename === action.payload.old_applicationPhase
					? { ...applicationPhase, ...action.payload.updated_applicationPhase }
					: applicationPhase
			);
			state.applicationPhaseList = state.applicationPhaseList.map(applicationPhase =>
				applicationPhase._id.toString() === action.payload._id.toString()
					? { ...applicationPhase, ...action.payload }
					: applicationPhase
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateApplicationPhase.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateApplicationPhase.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteApplicationPhase.fulfilled, (state, action) => {
			state.itemApplicationPhaseList = current(state.itemApplicationPhaseList).filter(
				item => item._id !== action.payload._id
			);
			state.applicationPhaseList = current(state.applicationPhaseList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteApplicationPhase.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteApplicationPhase.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ApplicationPhaseSlice.actions;

export default ApplicationPhaseSlice.reducer;
